export function sortClasses(arr) {
  const classOrder = [
    "Nursery", "LKG", "UKG",
    "I", "II", "III", "IV", "V", "VI",
    "VII", "VIII", "IX", "X", "XI", "XII"
  ];

  const parseName = (name) => {
    const [cls, section] = name.split("-");
    return { cls, section };
  };

  const getClassIndex = (cls) => {
    const idx = classOrder.indexOf(cls);
    return idx === -1 ? Infinity : idx; // Unknowns go to end
  };

  return arr.sort((a, b) => {
    const { cls: clsA, section: secA } = parseName(a.name);
    const { cls: clsB, section: secB } = parseName(b.name);

    const classCompare = getClassIndex(clsA) - getClassIndex(clsB);
    if (classCompare !== 0) return classCompare;

    // Same class → compare sections alphabetically
    return secA.localeCompare(secB);
  });
}
